"use client"

import PropTypes from "prop-types"

import { AuthNavigation } from "@/components/Navigation"
import { ScreenSizeWarning } from "@/components/ScreenSizeWarning"
import { useLocaleStrings } from "@/providers/localeStrings/client"
import { AppSettings } from "@/settings"

import { AuthContainer, H1, Main } from "./styled"

export function AuthLayout({ title = "ADM APP", children }) {
  const isIdmApp = AppSettings.isIdmApp()
  const { IDM_APP_TITLE } = useLocaleStrings()

  return (
    <AuthContainer>
      <ScreenSizeWarning />
      <AuthNavigation />
      <Main>
        <H1>{isIdmApp ? IDM_APP_TITLE : title}</H1>
        {children}
      </Main>
    </AuthContainer>
  )
}

AuthLayout.propTypes = {
  /** The main content */
  children: PropTypes.node.isRequired,
  /** Title of the page */
  title: PropTypes.string,
}
